import { render, staticRenderFns } from "./NavCategoriesLink.vue?vue&type=template&id=c9fee09e&scoped=true&"
import script from "./NavCategoriesLink.vue?vue&type=script&lang=js&"
export * from "./NavCategoriesLink.vue?vue&type=script&lang=js&"
import style0 from "./NavCategoriesLink.vue?vue&type=style&index=0&id=c9fee09e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fee09e",
  null
  
)

export default component.exports